//allow years from 1900-2099
export const VALIDATE_YEAR = /^(19|20)\d{2}$/;

export const YEAR_FORMAT = /^[0-9]{0,4}$/;

export const DAY_FORMAT = /^[0-9]{0,2}$/;
